import { type SvgProps, SvgWrapper } from '../utils';
export function UndoIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M20.25 17C20.25 14.812 19.3812 12.7132 17.834 11.166C16.2868 9.61884 14.188 8.75 12 8.75C9.97001 8.75225 8.01222 9.50301 6.50098 10.8584L4.95508 12.25H9C9.41421 12.25 9.75 12.5858 9.75 13C9.75 13.4142 9.41421 13.75 9 13.75H3C2.58579 13.75 2.25 13.4142 2.25 13V7C2.25 6.58579 2.58579 6.25 3 6.25C3.41421 6.25 3.75 6.58579 3.75 7V11.3154L5.49805 9.74219L5.49902 9.74121C7.28521 8.13924 9.5997 7.2525 11.999 7.25H12C14.5859 7.25 17.0661 8.27699 18.8945 10.1055C20.723 11.9339 21.75 14.4141 21.75 17C21.75 17.4142 21.4142 17.75 21 17.75C20.5858 17.75 20.25 17.4142 20.25 17Z" />
    </SvgWrapper>
  );
}
